import React from "react";
import { Link } from "react-router-dom";
import { FacebookLogo, InstagramLogo, LinkedinLogo, TiktokLogo } from "@phosphor-icons/react";
import { useLang } from "../i18n";

const AGENCY_LOGO =
  "https://customer-assets.emergentagent.com/job_exclusive-pm/artifacts/k9uzpwx6_20251205_225200000_iOS.jpg";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#0B0B0B] border-t border-white/5 pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="font-serif text-3xl text-[#D4AF37] mb-3">Roland Azar</div>
          <div className="text-white/50 text-xs uppercase tracking-[0.25em] mb-4">L'Expert immobilier P.M.</div>
          <img
            src={AGENCY_LOGO}
            alt="L'Expert immobilier P.M."
            className="h-16 w-auto object-contain mb-6"
          />
          <p className="text-white/50 text-sm leading-relaxed max-w-xs">{t.footer.tag}</p>
        </div>

        <div>
          <div className="eyebrow mb-6">{t.footer.links}</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/" className="link-underline hover:text-[#D4AF37]">{t.nav.home}</Link></li>
            <li><Link to="/sell" className="link-underline hover:text-[#D4AF37]">{t.nav.sell}</Link></li>
            <li><Link to="/buy" className="link-underline hover:text-[#D4AF37]">{t.nav.buy}</Link></li>
            <li><Link to="/rent" className="link-underline hover:text-[#D4AF37]">{t.nav.rent}</Link></li>
            <li><Link to="/about" className="link-underline hover:text-[#D4AF37]">{t.nav.about}</Link></li>
            <li><Link to="/contact" className="link-underline hover:text-[#D4AF37]">{t.nav.contact}</Link></li>
          </ul>
        </div>

        <div>
          <div className="eyebrow mb-6">{t.footer.contact}</div>
          <address className="not-italic text-sm text-white/70 leading-relaxed space-y-2">
            <div>3310, 100e Avenue, bureau 340</div>
            <div>Laval, Québec — H7T 0J7</div>
            <div>
              <a href="tel:5142747575" className="link-underline hover:text-[#D4AF37]">B: 514.274.7575</a>
            </div>
            <div className="pt-4">
              <a href="mailto:contact@rolandazar-courtierimmobilier.com" className="link-underline hover:text-[#D4AF37] whitespace-nowrap text-[0.82rem]">
                contact@rolandazar-courtierimmobilier.com
              </a>
            </div>
            <div>
              <a href="tel:5145725507" className="link-underline hover:text-[#D4AF37]">T: 514.572.5507</a>
            </div>
          </address>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-12 mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="text-white/30 text-xs tracking-wider">© {year} Roland Azar — {t.footer.rights}</div>
        <div className="flex items-center gap-5" data-testid="social-links">
          <a href="https://www.facebook.com/profile.php?id=61584530679218" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-white/50 hover:text-[#D4AF37] transition-colors" data-testid="social-facebook">
            <FacebookLogo size={20} weight="thin" />
          </a>
          <a href="https://www.instagram.com/rolandazarcourtierimmobilier" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-white/50 hover:text-[#D4AF37] transition-colors" data-testid="social-instagram">
            <InstagramLogo size={20} weight="thin" />
          </a>
          <a href="https://www.linkedin.com/in/roland-azar-669230274" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-white/50 hover:text-[#D4AF37] transition-colors" data-testid="social-linkedin">
            <LinkedinLogo size={20} weight="thin" />
          </a>
          <a href="https://www.tiktok.com/@rolandazar643" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="text-white/50 hover:text-[#D4AF37] transition-colors" data-testid="social-tiktok">
            <TiktokLogo size={20} weight="thin" />
          </a>
        </div>
        <Link to="/admin" className="text-white/30 text-xs hover:text-[#D4AF37] tracking-[0.2em] uppercase" data-testid="footer-admin-link">
          {t.nav.admin}
        </Link>
      </div>
    </footer>
  );
}
